import { OutlinedHeaderButton } from "../../../RoutineOccasion/RoutineOccasionScreen/OutlinedHeaderButton";
import React from "react";

export function StorecastCloseButton(props: { onPress(): void }) {
  return (
    <OutlinedHeaderButton
      icon="clear"
      spaceLeft="small"
      spaceRight="small"
      tintColor="text-primary"
      onPress={props.onPress}
    />
  );
}
